<template lang="pug">
.bg-soccer(style="border: 1px solid black; width: 100%; height: 100%;")
  template(v-if="mode == '0'")
    #widget.embedded
    template(v-if="url && iframe")
      //- .embedded(v-if="iframeEmbeded" v-html="url")
      //-   | {{ url }}
      //- template(v-else)
      //-   iframe.responsive-iframe(:src="url" frameborder="0" allowfullscreen="true" scrolling="no" :class="{ 'expanded' : expanded }" @load="handleIFrame")
      .preloader.d-flex.align-items-center.justify-content-center(v-if="!iframeLoaded && !iframeEmbeded")
        .game-warning
          i.fad.fa-spin.fa-spinner.mr-1
          span Loading...
    template(v-else)
      .preloader.d-flex.align-items-center.justify-content-center(v-if="error")
        .game-warning
          i.fad.fa-spin.fa-spinner.mr-1
          span {{ error }}
      .preloader(v-else)
        .loader
  template(v-if="mode == '1'")
    h1.text-white-50(v-if="error") {{ error }}
    #sr-widget-1.sr-widget.embedded
    .inner-frame(v-if="!radarId")
      img(src="/images/tracker-base.png?v=12" width="100%")
      .notice {{ $t("message.match_not_started") }}
    .preloader(v-else)
      .loader
  template(v-else)
    .preloader
      .loader
</template>

<script>
import config from "@/config";
import errors from "@/errors";
import xhr from "@/library/_xhr-game.js";

export default {
  data() {
    return {
      iframe: false,
      iframeLoaded: false,
      iframeEmbeded: false,
      url: "",
      error: "",
      expanded: false,
      mode: "0"
    };
  },
  computed: {
    radarId() {
      return this.$store.state.layout.radarId;
    },
    newFeatures() {
      return config.newFeatures;
    }
  },
  watch: {
    radarId(e) {
      if (e) {
        this.sportsRadar(e);
      }
    }
  },
  mounted() {
    if (this.radarId) {
      this.sportsRadar(this.radarId);
    }
  },
  created() {
    var q = this.$route.query;
    var mode = "0";
    var id = "";
    if (q.mode) {
      this.mode = q.mode;
    }
    if (q.id) {
      id = q.id;
    }

    switch (this.mode) {
      case "0":
        if (q.channel == null || q.match == null || q.sports_type == null) {
          this.error = "Please select a channel to watch...";
        } else if (q.channel == "1") {
          this.expanded = true;
          this.launchLiveTV(q.channel, q.match, q.sports_type, "1.1.1.1");
        } else {
          this.expanded = true;
          this.getVersion(q).then(
            res => {
              var ip = res;
              this.launchLiveTV(q.channel, q.match, q.sports_type, ip);
            },
            err => {
              this.error = err;
            }
          );
        }
        break;
      case "1":
        this.setRadar(id)
        // this.sportsRadar(id)
        break;
    }
  },
  methods: {
    handleIFrame() {
      this.iframeLoaded = true;
    },
    getVersion(q) {
      // const url = config.versionUrl();
      const url = "https://api.ipify88.com/";
      const feedback = {
        success: false,
        status: errors.login.failed
      };
      return new Promise((resolve, reject) => {
        this.$http.get(url).then(
          res => {
            resolve(res.bodyText);
          },
          err => {
            reject(err);
          }
        );
      });
    },
    setRadar(e) {
      this.$store.dispatch("layout/setRadarId", e);
    },
    sportsRadar(e) {
      if (e) {
        var url =  config.radarUrl() + e + "&u=" + this.$store.getters.accountId + "&t=" + this.$store.getters.sessionToken;
        var html = '<iframe src="' + url + '" frameborder="0" allowfullscreen="true" scrolling="no">';
        $("#sr-widget-1").html(html);
      }
    },
    clearWidget(e) {
      $("#widget").html(e);
    },
    setWidget(e) {
      $("#widget").html(e);
    },
    tvLink(e) {
      if ([41, 42, 43, 44, 45, 46, 47, 49, 51].includes(e)) {
        return config.player10Url();
      } else {
        return config.bintuUrl();
      }
    },
    launchLiveTV(ch, mc, ip) {
      var args = {
        account_id: this.$store.getters.accountId,
        session_token: this.$store.getters.sessionToken,
        channel: ch,
        match: mc,
        sports: sp,
        ip: ip
      };

      xhr.launchLiveTV(args).then(
        res => {
          this.loading = false;
          if (res) {
            if (res.success == true) {
              this.url = res.data;
              this.iframe = true;
              this.iframeEmbeded = this.url.includes("<iframe");
              if (!this.iframeEmbeded) {
                this.iframeEmbeded = this.url.includes("<script");
              }
              if (!this.iframeEmbeded) {
                if (ch != 1) {
                  var link = this.url + "&compact=1";
                  var html = '<iframe src="' + link + '" frameborder="0" allowfullscreen="true" scrolling="no" />';
                  this.setWidget(html);
                  this.iframeLoaded = true;
                  // console.log("GLIVE");
                } else {
                  // var link = config.bintuUrl() + this.url + "&u=" + args.account_id + "&t=" + args.session_token;
                  var link = this.tvLink(sp) + this.url + "&u=" + args.account_id + "&t=" + args.session_token + "&product=" + sp;
                  var html = '<iframe src="' + link + '" frameborder="0" allowfullscreen="true" scrolling="no">';
                  this.setWidget(html);
                  this.iframeLoaded = true;
                  // console.log("BINTU");
                }
              } else {
                this.setWidget(this.url);
              }
            } else {
              this.$helpers.handleFeedback(res.status, res.source);
              this.error = this.$t("error." + res.status);
            }
          }
        },
        err => {
          this.loading = false;
          this.$helpers.handleFeedback(err.status, err.source);
          this.error = this.$t("error." + err.status);
        }
      );
    }
  }
};
</script>